import React, { useId } from "react";
import { cn } from "@/lib/utils";

export function DotPattern({
  className,
  width = 22,
  height = 22,
  cx = 1.3,
  cy = 1.3,
  cr = 1.1,
  ...props
}) {
  const patternId = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("absolute inset-0 h-full w-full", className)}
      {...props}
    >
      <defs>
        <pattern
          id={patternId}
          x="0"
          y="0"
          width={width}
          height={height}
          patternUnits="userSpaceOnUse"
        >
          <circle cx={cx} cy={cy} r={cr} fill="currentColor" />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill={`url(#${patternId})`} />
    </svg>
  );
}
